<template>
  <div class="c-select c-select--no-before select-license">
    <transition name="fade">
      <div>
        <CheckboxListItem
          v-show="show"
          :item="{
            checked: checked,
            value: value,
            title: title
          }"
          v-on:childToParent="childToParent"
        />
        <span class="select-license__validate">{{ valid ? 'Skal udfyldes' : '' }}</span>
      </div>
    </transition>
  </div>
</template>
<script>
// @ is an alias to /src
import CheckboxListItem from '@/components/checkbox-list/checkbox-list-item.vue';

export default {
  name: 'SelectLicense',
  components: {
    CheckboxListItem
  },
  methods: {
    childToParent(e) {
      this.$emit('childToParent', e);
    }
  },
  props: {
    checked: Boolean,
    value: Boolean,
    title: String,
    valid: Boolean,
    show: Boolean
  }
};
</script>
<style lang="scss">
@import '@/assets/scss/essentials/essentials.scss';
@import './select-license';
</style>
